<template>
  <!-- 添加或修改菜单对话框 -->
  <el-dialog :title="form.id?'编辑':'新增'" :visible.sync="formVisible" width="700px" append-to-body close-on-click-modal>
    <el-form ref="dataForm" :rules="formRules" :model="form" size="small" label-width="120px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="上级菜单" prop="parentId">
            <treeselect v-model="form.parentId" :options="menuOptions" :normalizer="normalizer" :show-count="true" placeholder="选择上级菜单" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="菜单类型" prop="resType">
            <el-radio-group v-model="form.resType">
              <el-radio v-for="item in enums.resType" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="form.resType != 3">
          <el-form-item label="菜单图标" prop="icon">
            <el-popover placement="bottom-start" width="460" trigger="click" @show="$refs['iconSelect'].reset()">
              <IconSelect ref="iconSelect" @selected="selected" />
              <el-input slot="reference" v-model="form.icon" placeholder="点击选择图标" readonly>
                <!-- <svg-icon v-if="form.icon" slot="prefix" :icon-class="form.icon" class="el-input__icon" style="height: 32px;width: 16px;" /> -->
                <i v-if="form.icon" slot="prefix" class="el-input__icon sle-icon" :class="form.icon"></i>
                <i v-else slot="prefix" class="el-icon-search el-input__icon" />
                <i v-if="form.icon" slot="suffix" class="el-icon-close el-input__icon" style="cursor: pointer;" @click="removeIcon" />
              </el-input>
            </el-popover>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="菜单名称" prop="resName">
            <el-input v-model="form.resName" placeholder="请输入菜单名称" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="标记菜单" prop="activeMenu" v-if="form.resType == 2">
            <el-input v-model="form.activeMenu" placeholder="请输入标记菜单路由地址" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="显示排序" prop="orderNo">
            <el-input-number v-model="form.orderNo" controls-position="right" :min="0" />
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="form.resType != 3">
          <el-form-item prop="resCode">
            <span slot="label">
              <el-tooltip content="访问的路由地址，如：`user`" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
              路由地址
            </span>
            <el-input v-model="form.resCode" placeholder="请输入路由地址" />
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="form.resType == 2">
          <el-form-item prop="componentUrl">
            <span slot="label">
              <el-tooltip content="访问的组件路径，如：`system/user/index`，默认在`views`目录下" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
              组件路径
            </span>
            <el-input v-model="form.componentUrl" placeholder="请输入组件路径" />
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="form.resType != 1">
          <el-form-item prop="permissionIdentification">
            <el-input v-model="form.permissionIdentification" placeholder="请输入权限标识" maxlength="100" />
            <span slot="label">
              <el-tooltip content="控制器中定义的权限字符，如：@PreAuthorize(`@ss.hasPermi('system:user:list')`)" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
              权限字符
            </span>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="form.resType != 3">
          <el-form-item prop="hidden">
            <span slot="label">
              <el-tooltip content="选择隐藏则路由将不会出现在侧边栏，但仍然可以访问" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
              显示状态
            </span>
            <el-radio-group v-model="form.hidden">
              <el-radio :label="false">显示</el-radio>
              <el-radio :label="true">隐藏</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="prompt">
            <span slot="label">
              <el-tooltip content="鼠标停在左侧树菜单上的提示标语" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
              提示语
            </span>
            <el-input v-model="form.prompt" placeholder="请输入提示语" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">取 消</el-button>
      <el-button type="primary" @click="doCreate()">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import sysMenuApi from '@/api/system/sysMenu'
import enums from '@/utils/enums'
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import IconSelect from "@/components/IconSelect";

function initFormBean() {
  const formBean = {
    parentId: null,
    permissionIdentification: null,
    icon: null,
    hidden: null,
    activeMenu: null,
    componentUrl: null,
    prompt: null,
    resCode: null,
    resName: null,
    resType: 1,
    orderNo: null
  }
  return formBean
}

export default {
  components: { Treeselect, IconSelect },
  data() {
    return {
      enums: {
        menuType: enums.getMenuType(),
        resType: enums.getMenuType()
      },
      form: initFormBean(),
      formVisible: false,
      formRules: {
        parentId: [
          { required: true, message: "上级菜单不能为空", trigger: "blur" }
        ],
        resName: [
          { required: true, message: "菜单名称不能为空", trigger: "blur" }
        ],
        orderNo: [
          { required: true, message: "菜单顺序不能为空", trigger: "blur" }
        ],
        resCode: [
          { required: true, message: "菜单顺序不能为空", trigger: "blur" }
        ],
        prompt: [
          { required: true, message: "请输入提示语", trigger: "blur" }
        ],
      },
      // 菜单树选项
      menuOptions: []
    }
  },
  created() {
    this.getTreeselect()
  },
  methods: {
    removeIcon() {
      this.form.icon = '';
    },
    /** 转换菜单数据结构 */
    normalizer(node) {
      if (node.children && !node.children.length) {
        delete node.children;
      }
      return {
        id: node.id,
        label: node.resName,
        children: node.children
      };
    },
    /** 查询菜单下拉树结构 */
    getTreeselect() {
      sysMenuApi.fetchList({
        pageNo: 1,
        pageSize: 999
      }).then(({ data }) => {
        this.menuOptions = [];
        const menu = { id: 0, resName: '主类目', children: [] };
        menu.children = this.handleTree(data.list, "id");
        this.menuOptions.push(menu);
      });
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.form = initFormBean()
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.resetForm()

      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.form = { ...row }
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    /**
     * 执行新建操作
     */
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.form.id > 0) {
            sysMenuApi.update(this.form).then((data) => {
              this.postCallback(data)
            });
          } else {
            sysMenuApi.create(this.form).then((data) => {
              this.postCallback(data)
            });
          }
        }
      });
    },
    postCallback() {
      this.getTreeselect()
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
    // 选择图标
    selected(name) {
      this.form.icon = name;
    },
  }
}
</script>
<style lang="scss" scoped>
.icon-row {
  font-size: 20px;
}

.mb8 {
  margin-bottom: 8px;
}

::v-deep .el-input__prefix {
  // top: 4px;
}
</style>